import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RenderError from './RenderError';
import {
  consideredPowerSourcesChoices,
  whyChoosePropaneChoices,
  decisionMakerChoices
} from './config';
import { consideredPowerSourcesChoices as flameWeedingConsideredPowerSourcesChoices } from '../FlameWeeding/components/config';
import Success from './Success';
import Submit from './Submit';

function PurchasingDecision({
  applicationData: {
    aid,
    equipmentType,
    typicalOperationYears,
    typicalOperationHours,
    additionalOperationDetails,
    consideredPowerSources,
    consideredPowerSourcesOtherText,
    whyChoosePropane,
    whyChoosePropaneOtherText,
    decisionMaker,
    decisionMakerName,
    decisionMakerTitle
  },
  setApplicationData,
  initialView,
  setView
}) {
  const [formData, setFormData] = useState({
    aid: aid ?? '',
    equipmentType: equipmentType ?? '',
    typicalOperationYears: typicalOperationYears ?? '',
    typicalOperationHours: typicalOperationHours ?? '',
    additionalOperationDetails: additionalOperationDetails ?? '',
    consideredPowerSources: consideredPowerSources ?? [],
    consideredPowerSourcesOtherText: consideredPowerSourcesOtherText ?? '',
    whyChoosePropane: whyChoosePropane ?? [],
    whyChoosePropaneOtherText: whyChoosePropaneOtherText ?? '',
    decisionMaker: decisionMaker ?? '',
    decisionMakerName: decisionMakerName ?? '',
    decisionMakerTitle: decisionMakerTitle ?? ''
  });
  const [
    showDecisionMakerOtherFields,
    setShowDecisionMakerOtherFields
  ] = useState(false);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const choices = Object.values(decisionMakerChoices).filter(
      (choice) => choice !== decisionMakerChoices.me
    );
    let show = choices.includes(formData.decisionMaker);
    setShowDecisionMakerOtherFields(show);
  }, [formData.decisionMaker]);

  const handleCheck = (event, question) => {
    const { value } = event.target;

    if (formData[question].includes(value)) {
      let newFormData = formData[question].filter(
        (selected) => selected !== value
      );
      setFormData({ ...formData, [question]: newFormData });
    } else {
      let newFormData = formData[question];
      newFormData.push(value);
      setFormData({ ...formData, [question]: newFormData });
    }
  };

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const renderOtherInput = (
    test,
    data,
    name,
    value,
    handleInputChange,
    errors
  ) => {
    if (test == 'Other (please specify)') {
      if (data.includes(test)) {
        return (
          <div className="u--margin-top-10 u--margin-left-10">
            <textarea
              value={value}
              name={name}
              onChange={handleInputChange}
              className="form__textarea u--margin-right-10"
            />
            {errors && <RenderError error={errors} />}
          </div>
        );
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors([]);
    setSuccess('');

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_fip_purchase_decision',
        formData
      )
      .then((res) => {
        setLoading(false);
        setSuccess(res.data.data.message);
        setApplicationData(res.data.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-unit-form">
      <div className="fip-unit-form-fields">
        <div className="grid__col-xs-12 u--padding-left-0">
          <div className="form__field form__field--required">
            <label className="form__label">
              How long do you typically operate this equipment before replacing
              it?
            </label>
            <span className="u--margin-right-10">Years</span>
            <input
              type="number"
              value={formData.typicalOperationYears}
              className="form__input form__input--lg u--margin-bottom-10"
              name="typicalOperationYears"
              onChange={handleInputChange}
            />
            {errors.typicalOperationYears && (
              <RenderError error={errors.typicalOperationYears} />
            )}
            <span className="u--margin-right-10">Operating Hours</span>
            <input
              type="number"
              value={formData.typicalOperationHours}
              className="form__input form__input--lg u--margin-bottom-10"
              name="typicalOperationHours"
              onChange={handleInputChange}
            />
            {errors.typicalOperationHours && (
              <RenderError error={errors.typicalOperationHours} />
            )}
            <span className="u--margin-right-10">
              Please add additional details here
            </span>
            <textarea
              className="form__textarea u--margin-bottom-10"
              value={formData.additionalOperationDetails}
              name="additionalOperationDetails"
              onChange={handleInputChange}
            />
            {errors.additionalOperationDetails && (
              <RenderError error={errors.additionalOperationDetails} />
            )}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              {equipmentType === 'flameWeeding'
                ? 'What other weed control methods besides this propane-fueled flame weed system were you considering? Check all that apply.'
                : 'What other power sources besides this propane-fueled equipment were you considering? (select all that apply)'}
            </label>
            {errors.consideredPowerSources && (
              <RenderError error={errors.consideredPowerSources} />
            )}
            {Object.entries(
              equipmentType === 'flameWeeding'
                ? flameWeedingConsideredPowerSourcesChoices
                : consideredPowerSourcesChoices
            ).map((source) => (
              <div key={source[0]}>
                <label className="form__checkbox">
                  <input
                    type="checkbox"
                    value={source[1]}
                    checked={formData.consideredPowerSources.includes(
                      source[1]
                    )}
                    onChange={(event) =>
                      handleCheck(event, 'consideredPowerSources')
                    }
                  />
                  {source[1]}
                </label>
                {renderOtherInput(
                  source[1],
                  formData.consideredPowerSources,
                  'consideredPowerSourcesOtherText',
                  formData.consideredPowerSourcesOtherText
                    ? formData.consideredPowerSourcesOtherText
                    : '',
                  handleInputChange,
                  errors.consideredPowerSourcesOtherText
                )}
              </div>
            ))}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              Why did you choose to purchase propane-fueled equipment? (select
              all that apply)
            </label>
            {errors.whyChoosePropane && (
              <RenderError error={errors.whyChoosePropane} />
            )}
            {Object.entries(whyChoosePropaneChoices).map((reason) => (
              <div key={reason[0]}>
                <label className="form__checkbox">
                  <input
                    type="checkbox"
                    value={reason[1]}
                    checked={formData.whyChoosePropane.includes(reason[1])}
                    onChange={(event) => handleCheck(event, 'whyChoosePropane')}
                  />
                  {reason[1]}
                </label>
                {renderOtherInput(
                  reason[1],
                  formData.whyChoosePropane,
                  'whyChoosePropaneOtherText',
                  formData.whyChoosePropaneOtherText
                    ? formData.whyChoosePropaneOtherText
                    : '',
                  handleInputChange,
                  errors.whyChoosePropaneOtherText
                )}
              </div>
            ))}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              Who was the final decision maker for purchasing your new propane
              equipment through the Propane Farm Research Program? (select one)
            </label>
            {errors.decisionMaker && (
              <RenderError error={errors.decisionMaker} />
            )}
            {Object.values(decisionMakerChoices).map((option) => (
              <label className="form__radio" key={option}>
                <input
                  type="radio"
                  name="decisionMaker"
                  value={option}
                  checked={formData.decisionMaker === option}
                  onChange={handleInputChange}
                />
                {option}
              </label>
            ))}
          </div>
          {showDecisionMakerOtherFields && (
            <>
              <p>
                <b>
                  Please provide the name and title of the final decision maker.
                </b>
              </p>
              <div className="form__field form__field--required">
                <label
                  className="form__label u--margin-right-20"
                  htmlFor="decisionMakerName"
                >
                  Name:
                </label>
                <input
                  type="text"
                  name="decisionMakerName"
                  value={formData.decisionMakerName}
                  className="form__input form__input--lg"
                  onChange={handleInputChange}
                />
                {errors.decisionMakerName && (
                  <RenderError error={errors.decisionMakerName} />
                )}
              </div>
              <div className="form__field form__field--required">
                <label
                  className="form__label u--margin-right-20"
                  htmlFor="decisionMakerTitle"
                >
                  Title:
                </label>
                <input
                  type="text"
                  name="decisionMakerTitle"
                  value={formData.decisionMakerTitle}
                  className="form__input form__input--lg"
                  onChange={handleInputChange}
                />
                {errors.decisionMakerTitle && (
                  <RenderError error={errors.decisionMakerTitle} />
                )}
              </div>
            </>
          )}
          <Submit
            loading={loading}
            handleSubmit={handleSubmit}
            text="Save Section"
            errors={errors}
            disabled={!Boolean(aid)}
          />
          {success && <Success success={success} />}
        </div>
      </div>
    </div>
  );
}

PurchasingDecision.displayName = 'PurchasingDecision'; // because WebPack renames the function
export default PurchasingDecision;
